<template>
  <div id="cart-details" class="bg-gray">

    <section id="cart-summary-items">
      <div class="container">
        <cart-items-list :view-mode="'details'"></cart-items-list>
      </div>
    </section>

    <shipments></shipments>

    <discount></discount>
    <section id="total" class="bg-gray">
      <div class="container">
        <div class="cart-row summary">
          <p v-translate="'CART_order_total'">Kwota do zapłaty</p>
          <h3 v-html="getPrice(orderTotal)"></h3>
        </div>
      </div>
    </section>

    <section id="navi-buttons" class="bg-gray">
      <div class="container">
        <div class="cart-row">
          <div class="continue"><div class="arrow-left"></div><a :href="getContinueShoppingLink()" v-translate="'CART_continue_shopping'">Kontynuuj zakupy</a></div>
          <button @click="redirectAddress()" class="btn mint" v-bind:disabled="!hasShipment" v-translate="'CART_go_checkout'"></button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

  import CartItemsList from './CartItemsList';
  import Discount from './Discount';
  import Shipments from "./Shipments";
  import store from "./../../store/index"

  export default {
    name: "Details",
    components: {Shipments, CartItemsList, Discount},
    computed: {

      itemsTotal() {
        return store.getters.itemsTotal;
      },
      discountValue() {
        return store.getters.discountValue;
      },
      shipment() {
        return store.getters.shipment;
      },
      hasShipment() {
        return this.shipment.internal_name !== '';
      },



      orderTotal() {
        let total = this.itemsTotal;
        let shipmentCost = store.getters.shipmentCost / 100;
        total += shipmentCost;
        if (this.discountValue > total) {
          total = 0;
        }
        else {
          total -= this.discountValue
        }

        return total;
      },

    },
    data() {
      return {}
    },
    methods: {
      getContinueShoppingLink() {
        return window.translations['rt_continue_shopping'];
      },
      redirectAddress() {
        window.location.href = window.env.baseUrl + window.translations['rt_user_address'];
      },
      getPrice(price) {
        return this.$options.filters.full_price(price)
      },
    }
  }

</script>




// WEBPACK FOOTER //
// src/components/Cart/Details.vue